import { GET_DOCS_SOURCES } from "../types"
import { DEFAULT_SOURCES } from "../utils"

const initialState = {
	docs_sources: {
		sources: DEFAULT_SOURCES,
	},
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_DOCS_SOURCES:
			let newSources = state.docs_sources.sources
			//let fullSources =  action.payload.source.concat(newSources);
			let fullSources = [...new Set([...action.payload.source, ...DEFAULT_SOURCES])] //it will return the unique array
			//this is to show all sources
			return {
				...state,
				//docs_sources: action.payload
				docs_sources: { sources: fullSources },
			}
		default:
			return state
	}
}
